/* TODO: remove prior to launch */
@@include("./vendors/greensock/minified/plugins/ScrambleTextPlugin.min.js")
@@include("./vendors/rainyday/rainyday.min.js")

(function(){
  var windowsPC = new RegExp('Windows NT');
  var chromeOS = new RegExp('CrOS');
  if ( $('html').hasClass('no-touchevents') || windowsPC.test(navigator.userAgent) || chromeOS.test(navigator.userAgent) ) {
    var controller;
    $('html').addClass('init-scroll');
    setScrollTrigger();

    $(window).resize($.debounce(100,false,function(){
      setScrollTrigger();
    }));

    $('[data-video-src]').each(function(){
      $(this).html('<video src="'+$(this).attr('data-video-src')+'" autoplay loop poster="'+$(this).attr('data-video-poster')+'"/>');
    });

    $('.global-digital-snapshot-social-text span').each(function(){
      increaseNumber($(this));
    });

    $(window).on('load',function(){
      makeItRain();
      animateEmojis();
    });

    function setScrollTrigger() {
      if(controller != undefined) {controller=controller.destroy(true)}
      controller = new ScrollMagic.Controller();

      $('.intro-eye').css('opacity','0');
      new ScrollMagic.Scene({
        triggerElement: '.intro-eye',
        triggerHook: 'onEnter',
        offset: 300,
        reverse: false
      })
      .setTween('.intro-eye', 0.45, {opacity: 1})
      .addTo(controller);

      $('.a-sign-of-the-times-header-bg').css('opacity','0.3');
      new ScrollMagic.Scene({
        triggerElement: '.a-sign-of-the-times-header'
      })
      .setTween('.a-sign-of-the-times-header-bg',0.6,{opacity:1})
      .addTo(controller);

      $('.a-sign-of-the-times-bg-image').css('opacity','0');
      new ScrollMagic.Scene({
        triggerElement: '.a-sign-of-the-times-bg-image',
        duration: $('.a-sign-of-the-times-bg-image').outerHeight() * 0.75
      })
      .setTween('.a-sign-of-the-times-bg-image', 1, {opacity: 1})
      .addTo(controller);

      new ScrollMagic.Scene({
        triggerElement: '.as-above-so-below-cross',
        duration: ($('.as-above-so-below-image').outerHeight() * 1),
        offset:  ($('.as-above-so-below-cross').outerHeight() / 4) + $('.as-above-so-below-image').outerHeight() / 2
      })
      .on("progress", function (e) {
        TweenLite.to('.as-above-so-below-image', 0, {y: 80 - (e.progress * 80) +'%'});
      })
      .addTo(controller);

      $('.video-player').css({'opacity':'0'});
      new ScrollMagic.Scene({
        triggerElement: '.video-player',
        duration: $('.video-player').outerHeight()
      })
      .on("enter", function (e) {
        TweenLite.to('.video-player', 0.6, {opacity: 1});
      })
      .on("leave", function (e) {
        TweenLite.to('.video-player', 0.6, {opacity: 0});
      })
      .addTo(controller);

      $('.outside-of-society-bg1').css('opacity','0');
      new ScrollMagic.Scene({
        triggerElement: '.outside-of-society-bg1',
        duration: $('.outside-of-society-bg1').outerHeight() * 0.75
      })
      .setTween('.outside-of-society-bg1', 1, {opacity: 1})
      .addTo(controller);

      $('.terrorist-stat-copy').css({'opacity':'0'});
      $('.terrorist-stat-number').each(function(){
        $(this).on('mouseenter',function(){
          TweenLite.to(this, 2, {scrambleText:{text:$(this).text(), chars: '1234567890'}});
        })
      })
      new ScrollMagic.Scene({
        triggerElement: '.terrorist-stat',
        offset: -$(window).outerHeight() / 4,
        reverse: false
      })
      .on("enter", function (e) {
        TweenLite.to('.terrorist-stat-copy', 0.6, {opacity: 1});
        $('.terrorist-stat-number').each(function(){
          TweenLite.to(this, 2, {scrambleText:{text:$(this).text(), chars: '1234567890'}});
        })
      })
      .on("leave", function (e) {
        TweenLite.to('.terrorist-stat-copy', 0.6, {opacity: 0});
      })
      .addTo(controller);

      $('.the-devil-made-me-do-it-banner').css('opacity','0');
      new ScrollMagic.Scene({
        triggerElement: '.the-devil-made-me-do-it-banner',
        duration: ($('.the-devil-made-me-do-it-banner').outerHeight() * 0.75)
      })
      .setTween('.the-devil-made-me-do-it-banner', 1, {opacity: 1})
      .addTo(controller);

      $('.the-devil-made-me-do-it-ram').css({'transform':'translateX(10%)','opacity':'0'});
      new ScrollMagic.Scene({
        triggerElement: '.the-devil-made-me-do-it-ram',
      })
      .setTween('.the-devil-made-me-do-it-ram', 1, {
          opacity: 1,
          x: 0
      })
      .addTo(controller);

      // if ($(window).outerWidth() >= 768 ) {
      //   $('.the-devil-made-me-do-it-ram').css({'transform':'translateX(10%)','opacity':'0'});
      //   new ScrollMagic.Scene({
      //     triggerElement: '.the-devil-made-me-do-it-ram-ctn',
      //     triggerHook: 'onLeave',
      //     duration: $('.the-devil-made-me-do-it-copy').outerHeight() - $('.the-devil-made-me-do-it-ram-ctn').outerHeight()
      //   })
      //   .setPin('.the-devil-made-me-do-it-ram-ctn')
      //   .setTween('.the-devil-made-me-do-it-ram', 1, {
      //       opacity: 1,
      //       x: 0
      //   })
      //   .addTo(controller);
      // } else {
      //   $('.the-devil-made-me-do-it-ram').css({'transform':'translateX(10%)','opacity':'0'});
      //   new ScrollMagic.Scene({
      //     triggerElement: '.the-devil-made-me-do-it-ram',
      //   })
      //   .setTween('.the-devil-made-me-do-it-ram', 1, {
      //       opacity: 1,
      //       x: 0
      //   })
      //   .addTo(controller);
      // }

      $('.im-a-ghost-header-image1').css('opacity','1');
      new ScrollMagic.Scene({
        triggerElement: '.im-a-ghost-header-image1',
        duration: ($('.im-a-ghost-header-image1').outerHeight() * .75),
        offset: ($('.im-a-ghost-header-image1').outerHeight() / 4)
      })
      .setTween('.im-a-ghost-header-image1', 1, {opacity:0})
      .addTo(controller);

      $('.im-a-ghost-title').css('opacity','0');
      new ScrollMagic.Scene({
        triggerElement: '.im-a-ghost-title',
        triggerHook: 'onEnter',
        duration: ($(window).outerHeight() * 0.75)
      })
      .setTween('.im-a-ghost-title', 1, {opacity: 1})
      .addTo(controller);

      $('.im-a-ghost-bg').css('opacity','1');
      new ScrollMagic.Scene({
        triggerElement: '.im-a-ghost-bg',
        duration: $(window).outerHeight(),
        offset: -$(window).outerHeight() / 4,
      })
      .on("progress", function (e) {
        if (e.progress < 0.73) {
          TweenLite.to('.im-a-ghost-bg', 0, {opacity: 1 - e.progress});
        }
      })
      .addTo(controller);

      new ScrollMagic.Scene({
        triggerElement: '.global-digital-snapshot-stats-bg',
        offset: -$(window).outerHeight() / 4,
        reverse: false
      })
      .setClassToggle('.global-digital-snapshot-stats-bg','trigger-active')
      .addTo(controller);

      $('.global-digital-snapshot-stats').css({'opacity':'0','transform':'translateX(30px)'});
      $('.global-digital-snapshot-stats').each(function(){
        var $this = $(this);
        new ScrollMagic.Scene({
          triggerElement: this,
          triggerHook: 'onEnter',
          offset: $(this).height(),
          reverse: false
        })
        .setTween(this, 0.6, {opacity:1,x:0})
        .on("enter", function (e) {
          TweenLite.to($this.find('.global-digital-snapshot-stats-number'), 2, {scrambleText:{text:$this.find('.global-digital-snapshot-stats-number').text(), chars: '1234567890'}});
        })
        .addTo(controller);
      });

      new ScrollMagic.Scene({
        triggerElement: '.global-digital-snapshot-content',
        triggerHook: 'onLeave',
        duration: $('.global-digital-snapshot-content').outerHeight() + $('.question').outerHeight()
      })
      .setClassToggle('.question','trigger-active')
      .addTo(controller);

      $('.we-are-afraid-of-ourselves-banner').css('opacity','0');
      new ScrollMagic.Scene({
        triggerElement: '.we-are-afraid-of-ourselves-banner',
        offset: $('.we-are-afraid-of-ourselves-banner').outerHeight() / 4
      })
      .setTween('.we-are-afraid-of-ourselves-banner',0.6,{opacity:1})
      .addTo(controller);
    }

  } else {
    $('[data-video-src]').each(function(){
      $(this).css({'background-image':'url('+$(this).attr('data-video-poster')+')'});
    });
    $('.global-digital-snapshot-social-text span').each(function(){
      increaseNumber($(this));
    })
    $(window).on('load',function(){
      animateEmojis();
    });
  }
})();

function animateNumber(element,time) {
  var num = parseInt(element.attr('data-number'));
  var i = 0;
  var interval = time/num;

  var countUp = setInterval(function() {
    if ( i < 10 ) {
      if ( element.attr('data-number').length == 2 ){
        var leadingZeros = '0';
      } else if ( element.attr('data-number').length == 3 ){
        var leadingZeros = '00';
      } else {
        var leadingZeros = '';
      }
      element.attr('data-count',leadingZeros+i);
    } else if ( i < 100 ) {
      if ( element.attr('data-number').length == 3 ){
        var leadingZeros = '0';
      } else {
        var leadingZeros = '';
      }
      element.attr('data-count',leadingZeros+i);
    } else {
      element.attr('data-count',i);
    }
    i++;
    if ( i > num ) {
      clearTimeout(countUp);
    }
  }, interval);
}

function increaseNumber(e) {
  var $element = $(e);
  var num = $element.text();
  var digit = isNaN(num) ? parseInt(num.replace( /,/g, "" )) : num;
  function increaseDigit(){
    var randomNum = Math.floor(Math.random() * 5) +1
    digit = (randomNum > 0) ? digit + randomNum : digit;
    $element.text(digit.toLocaleString());
    requestAnimationFrame(increaseDigit);
  }
  requestAnimationFrame(increaseDigit);
}

function animateEmojis() {
  function randomEmoji() {
    $('.emoji.active').removeClass('active');
    $('.emoji')[Math.floor(Math.random() * $('.emoji').length)].classList.add('active');
    setTimeout(function(){
      requestAnimationFrame(randomEmoji);
    },250)
  }
  requestAnimationFrame(randomEmoji);
}

function makeItRain() {
  var image = document.getElementById('rain');
  image.onload = function() {
    var engine = new RainyDay({
      image: this,
      blur: 4,
      parentElement: document.querySelector('.a-sign-of-the-times-header-bg')
    });
    engine.rain([ [0, 2, 50], [3, 3, 1] ], 50);
  };
  image.crossOrigin = 'anonymous';
  image.src = '../assets/img/what-are-we-afraid-of/bates.jpg';
}

function animateMasks(){
    var images = {};
    var ctn = document.querySelector('.outside-of-society-masks-canvas');
    var ctn_style = getComputedStyle(ctn);
    var canvas = document.getElementById('masks');
    var ctx = canvas.getContext('2d');

    canvas.width = parseInt(ctn_style.getPropertyValue('width'));
    canvas.height = parseInt(ctn_style.getPropertyValue('height'));
    var imageSize = canvas.height;

    var sets = {
      '1': function() {
        ctx.drawImage(images['mask0'],0,0,imageSize,imageSize);
        ctx.drawImage(images['mask1'],imageSize,0,imageSize,imageSize);
        ctx.drawImage(images['mask2'],(imageSize*2),0,imageSize,imageSize);
        ctx.drawImage(images['mask3'],(imageSize*3),0,imageSize,imageSize);
        ctx.drawImage(images['mask4'],(imageSize*4),0,imageSize,imageSize);
      },
      '2': function() {
        ctx.drawImage(images['mask2'],0,0,imageSize,imageSize);
        ctx.drawImage(images['mask4'],imageSize,0,imageSize,imageSize);
        ctx.drawImage(images['mask3'],(imageSize*2),0,imageSize,imageSize);
        ctx.drawImage(images['mask1'],(imageSize*3),0,imageSize,imageSize);
        ctx.drawImage(images['mask0'],(imageSize*4),0,imageSize,imageSize);
      },
      '3': function() {
        ctx.drawImage(images['mask3'],0,0,imageSize,imageSize);
        ctx.drawImage(images['mask0'],imageSize,0,imageSize,imageSize);
        ctx.drawImage(images['mask1'],(imageSize*2),0,imageSize,imageSize);
        ctx.drawImage(images['mask4'],(imageSize*3),0,imageSize,imageSize);
        ctx.drawImage(images['mask2'],(imageSize*4),0,imageSize,imageSize);
      },
      '4': function() {
        ctx.drawImage(images['mask1'],0,0,imageSize,imageSize);
        ctx.drawImage(images['mask2'],imageSize,0,imageSize,imageSize);
        ctx.drawImage(images['mask4'],(imageSize*2),0,imageSize,imageSize);
        ctx.drawImage(images['mask0'],(imageSize*3),0,imageSize,imageSize);
        ctx.drawImage(images['mask3'],(imageSize*4),0,imageSize,imageSize);
      },
      '5': function() {
        ctx.drawImage(images['mask4'],0,0,imageSize,imageSize);
        ctx.drawImage(images['mask3'],imageSize,0,imageSize,imageSize);
        ctx.drawImage(images['mask0'],(imageSize*2),0,imageSize,imageSize);
        ctx.drawImage(images['mask2'],(imageSize*3),0,imageSize,imageSize);
        ctx.drawImage(images['mask1'],(imageSize*4),0,imageSize,imageSize);
      }
    }

    // load images then call drawMasks
    function loadImages(source,callback) {
      var loadedImages = 0;
      if ( root == '.' ) {
        root = '..';
      }
      source.forEach(function(el,i){
        images['mask'+i] = new Image();
        images['mask'+i].onload = function() {
          if(++loadedImages >= source.length) {
            callback();
          }
        };
        images['mask'+i].src = root + source[i];
      });
    }
    loadImages(maskImages,drawMasks);

    // fade in masks animation
    function drawMasks() {
      var i = 1;
      var opacity = 0;
      function animateMasks() {
        if ( opacity <= 1 ) {
          ctx.globalAlpha = opacity;
          sets[i]();
          opacity += 0.03 + (opacity*0.07);
          // opacity +=0.075;
        } else {
          opacity = 0;
          ctx.globalAlpha = opacity;
          if(i < 5) {
            i++;
            sets[i]();
          } else {
            i = 1;
            sets[i]();
          }
        }
        requestAnimationFrame(animateMasks);
      }
      requestAnimationFrame(animateMasks);
    }

    // update canvas on resize
    $(window).resize(function(){
      ctn_style = getComputedStyle(ctn);
      canvas.width = parseInt(ctn_style.getPropertyValue('width'));
      canvas.height = parseInt(ctn_style.getPropertyValue('height'));
      imageSize = canvas.height;
    })
}
animateMasks();
